import React from "react";

import { Switch, Route, Redirect } from "react-router";
// import { withRouter } from 'react-router';
import { inject } from "mobx-react";
import { ThemeProvider } from "styled-components";
import { IntlProvider, defineMessages } from "react-intl";

import withTracker from "../utils/withTracker";

import Main from "./main";

import themes from "../utils/themes";
import locales from "../utils/locales";

const messages = defineMessages(locales);

const mapper = (stores, props) => ({
  theme: stores.uiStore.getTheme.get(),
  locale: stores.uiStore.getLocale.get()
});

export default inject(mapper)(({ locale, theme }) => (
  <IntlProvider locale={locale} messages={messages}>
    <ThemeProvider theme={themes[theme]}>
      <Switch>
        <Route
          exact
          path="/:locale(en-us|pt-br|fr-fr|sv-se)"
          component={Main}
        />
        <Route exact path="/" component={Main} />
        <Redirect exact from="*" to="/" />
      </Switch>
    </ThemeProvider>
  </IntlProvider>
));



// WEBPACK FOOTER //
// ./src/screens/index.js